import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import styles from '../css/ExerciseGuidelinesModal.module.css'

// Guidelines every user must acknowledge before working a targeting exercise (all teams).
// Dismissed only via OK — no overlay click / Escape — so the guidance is always read.
export default function ExerciseGuidelinesModal({ open, onAcknowledge }) {
    const okRef = useRef(null)

    useEffect(() => {
        if (open) okRef.current?.focus()
    }, [open])

    if (!open) return null

    return createPortal(
        <div className={styles.overlay}>
            <div
                className={styles.modal}
                role="dialog"
                aria-modal="true"
                aria-labelledby="exercise-guidelines-title"
            >
                <h2 id="exercise-guidelines-title" className={styles.title}>Targeting Exercise Key Instructions</h2>

                <div className={styles.body}>
                    <section>
                        <h3 className={styles.heading}>Dead, Inactive, Retired (DIR) Statuses</h3>
                        <p>
                            You may drop these HCPs to Non-Target in this exercise, but you must also update
                            their status in the MDM profile.{' '}
                            <span className={styles.warning}>
                                Marking an HCP as DIR makes the HCP a Non-Target for all teams, so please use this with caution.
                            </span>
                        </p>
                    </section>

                    <section>
                        <h3 className={styles.heading}>Incorrect Addresses / Territory Changes</h3>
                        <ul className={styles.list}>
                            <li>
                                <strong>If the HCP belongs to another territory and you know their address:</strong>{' '}
                                Please update the address in their MDM profile and coordinate with the Rep/OBD
                                covering that geography to review the target assignment. The HCP will be moved to
                                the correct territory after the refinement window closes.
                            </li>
                            <li>
                                <strong>If the HCP moved out of your territory and you do NOT know their new address:</strong>{' '}
                                Please move them to Non-Target and select/note the reason as
                                “Moved out of territory - address unknown.”
                            </li>
                        </ul>
                    </section>
                </div>

                <div className={styles.actions}>
                    <button ref={okRef} type="button" className={styles.ok} onClick={onAcknowledge}>OK</button>
                </div>
            </div>
        </div>,
        document.body
    )
}
